<template>
  <div class="mc-video-alert__video-item-state image-request">
    <div class="mc-video-alert__content-wrapper">
      <McButton
        icon="icon-outline_download"
        variant="outline-primary"
        size="small"
        class="btn-download-video"
        :text="'Request Foto'"
        :disabled="disabled"
        @click="$emit('clickRequestPhoto')"
      />
    </div>
  </div>
</template>
<script>
import McButton from '@/components/McButton'

export default {
  components: {
    McButton,
  },
  props: {
    disabled: {
      type: Boolean,
      required: true,
    },
  },
  emits: ['clickRequestPhoto'],
}
</script>

<style lang="scss">
.mc-video-alert__video-item-state.image-request {
  button {
    i {
      margin-bottom: 0;
    }
  }

  .btn-download-video.general-driver-behavior {
    button {
      background-color: $mep-primary;
    }
  }
  .btn-download-video {
    button {
      background-color: $white;
      &:hover:not(:disabled),
      &:focus:not(:disabled) {
        span {
          color: $white;
        }
      }
      span {
        color: $mep-primary;
      }
    }
  }
}
</style>
